export default __webpack_public_path__ + "static/high-elves-0ce5f33418026a2607bd9baa0f067237.webp";